/* eslint-disable */
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
// material
import { Autocomplete, Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, Button, } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { ToastContainer, toast } from 'react-toastify';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Services';
import permissionAuth from 'src/utils/permissionAuth';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { DatePicker, LocalizationProvider } from '@material-ui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';

export default function MarketPriceAddEdit() {
    const screenCode = 'MARKETPRICE';
    const navigate = useNavigate();
    const [isButtonEnable, setIsButtonEnable] = useState(false);
    const [productPriceID, setProductPriceID] = useState("");
    const [selectedProductCategory, setSelectedProductCategory] = useState(0);
    const [fromDate, setFromDate] = useState(new Date());
    const [productcatogery, setProductcatogery] = useState([]);
    const [product, setProduct] = useState([]);
    const [IsClear, setIsClear] = useState(false);
    const [groupList, setGroupList] = useState([]);
    const [canEdit, setCanEdit] = useState({
        editProductPrice: false
    });

    const [formData, setFormData] = useState({
        groupID: "",
        createdBy: "",
        productCategoryID: "",
        productID: "",
        productCategoryName: "",
        productName: "",
        sellingPrice: "",
        proposedPrice: "",
        competitorPrice: "",
        fromDate: new Date(fromDate).toISOString(),
        isActive: true
    });

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: false,
        submitButtonName: "Save",
        pageName: "Add Selling Price"
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false
    });

    const editValidationSchema = Yup.object().shape({
        groupID: Yup.number().required('Group is required'),
        productCategoryName: Yup.string().required('Product Category is required'),
        productName: Yup.string().required('Product Name is required'),
        sellingPrice: Yup.number().min(1, 'Please Enter a Selling Price').required('Selling Price is required'),
        proposedPrice: Yup.number().min(1, 'Please Enter a Proposed Price').required('Proposed Price is required'),
        //competitorPrice: Yup.number().min(1, 'Please Enter a Competitor Price').required('Competitor Price is required')
    });

    const addValidationSchema = Yup.object().shape({
        groupID: Yup.number().required('Group is required'),
        productCategoryID: Yup.string().required('Product Category is required'),
        productID: Yup.string().required('Product is required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required'),
        sellingPrice: Yup.number().min(0, 'Selling Price cannot be negative').required('Selling Price is required'),
        proposedPrice: Yup.number().min(1, 'Please Enter a Proposed Price').required('Proposed Price is required'),
        //competitorPrice: Yup.number().min(0, 'Selling Price cannot be negative').required('Competitor Price is required'),
    });

    const validationSchema = pageProps.isEdit ? editValidationSchema : addValidationSchema;

    const { operationEntityID } = useParams();
    let decrypted = 0;

    useEffect(() => {
        decrypted = AESDecryptionParam(operationEntityID);
        if (decrypted > 0) {
            setPageProps({
                ...pageProps,
                isEdit: true,
                submitButtonName: "Update",
                editingID: parseInt(decrypted),
                pageName: "Edit Selling Price"
            })
            setCanEdit({
                ...canEdit,
                editProductPrice: true
            });
            setProductPriceID(decrypted);
            SetDetailsForProductPriceEdit(decrypted);
        }
    }, []);

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
            isActive: formData.isActive,
            productCategoryID: formData.productCategoryID,
            productID: formData.productID,
            fromDate: fromDate || new Date(), 
            productCategoryName: formData.productCategoryName,
            productName: formData.productName,
            sellingPrice: formData.sellingPrice,
            proposedPrice: formData.proposedPrice,
            competitorPrice: formData.competitorPrice
        },

        validationSchema: validationSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        }
    });

    async function SetDetailsForProductPriceEdit(productPriceID) {

        if (canEdit != false) {
            let result = await services.GetProductPricesByProductPriceIDFromMarketPriceScreen(productPriceID);
            setValues({
                groupID: result[0].groupID,
                productCategoryName: result[0].productCategoryName,
                productName: result[0].productName,
                productID: result[0].productID,
                productCategoryID: result[0].productCategoryID,
                sellingPrice: result[0].sellingPrice,
                fromDate: result[0].fromDate,
                proposedPrice: result[0].proposedPrice,
                competitorPrice: result[0].competitorPrice == 0 || result[0].competitorPrice == null ? '' : result[0].competitorPrice,
                isActive: result[0].isActive,
            })
        }

    }
    async function SubmitForm() {
        if (canEdit.editProductPrice === false) {
            let model = {
                groupID: values.groupID,
                productCategoryID: values.productCategoryID,
                productID: values.productID,
                sellingPrice: Number(values.sellingPrice),
                proposedPrice: Number(values.proposedPrice),
                fromDate: values.fromDate,
                competitorPrice: Number(values.competitorPrice),
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                isActive: values.isActive
            };

            let res = await services.SaveMarketPriceDetails(model);

            if (res.data > 0) {
                toast.success("Product Prices Added Succesfully");
                formik.resetForm();
                setTimeout(() => {
                    navigate('/dashboard/viewSellingPrice');
                }, 800);
            } else if (res.data == -1) {
                toast.error("Product Prices are Already added");
            }
            else {
                toast.error("Error!.New Selling Price not created");
            }
        }
        else if (canEdit.editProductPrice != false) {
            let model = {
                groupID: values.groupID,
                productCategoryID: values.productCategoryID,
                productID: values.productID,
                productPriceID: parseInt(productPriceID),
                fromDate: values.fromDate,
                sellingPrice: Number(values.sellingPrice),
                proposedPrice: Number(values.proposedPrice),
                competitorPrice: Number(values.competitorPrice),
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                isActive: values.isActive
            };

            let res = await services.UpdateProductPriceDetails(model);
            if (res.statusCode === "Success") {
                toast.success(res.message);
                setTimeout(() => {
                    navigate('/dashboard/viewSellingPrice');
                    SetDetailsForProductPriceEdit(productPriceID);
                }, 3000);
            } else {
                toast.error(res.message);
                SetDetailsForProductPriceEdit(productPriceID);
            }
        }
        else {
            toast.error(res.message);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductDetailsByProductcatogeryID(formik.values.productCategoryID)
        if (res != null) {
            setProduct(res);
        }
    }

    async function GetProductCategoties() {
        var result = await services.GetProductCategoties()
        result.forEach(x => {
            x.productCategoryName = x.productCategoryName == null || x.productCategoryName == "" ? x.categoryCode : x.productCategoryName
        })
        setProductcatogery(result);
    }

    useEffect(() => {
        getPermissions();
    }, [])

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'MARKETPRICE');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        });
        trackPromise(GetProductCategoties());
    }

    useEffect(() => {
        GetAllGroups();
        trackPromise(GetProductCategoties());
    }, []);

    useEffect(() => {
        if (selectedProductCategory && selectedProductCategory !== 0) {
            setValues({
                ...formik.values,
                productCategoryID: selectedProductCategory
            });
        }
    }, [selectedProductCategory, formik.values]);

    useEffect(() => {
        if (!pageProps.isEdit) {
            setFormData({
                groupID: "",
                createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                productCategoryID: "",
                productID: "",
                productCategoryName: "",
                productName: "",
                fromDate: new Date(),
                sellingPrice: "",
                proposedPrice: "",
                competitorPrice: "",
                isActive: false
            });
            formik.resetForm();
        }
    }, [pageProps.isEdit]); 

    useEffect(() => {
        setFormData({
            groupID: "",
            fromDate: new Date(),
            sellingPrice: "",
            proposedPrice: "",
            competitorPrice: ""
        });
    }, [formik.values.productCategoryID,formik.values.productID,formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [formik.values.productCategoryID]);

    async function GetAllGroups() {
        var res = await services.GetAllGroupsForMarketScreen();
        if (res != null) {
            setGroupList(res);
        }
    }

    function clearAll() {
        setValues({
            ...values,
            productCategoryName: "",
            productCategoryID: "",
            productID:"",
            productName: "",
            sellingPrice: "",
            fromDate: "",
            proposedPrice: "",
            competitorPrice: "",
            isActive: false
        })
        formik.resetForm();
        setIsClear(!IsClear);
    }

    const { errors, touched, setValues, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    const filterOptions = (options, { inputValue }) => {
        const trimmedInput = inputValue.trim().toLowerCase();

        const filteredOptions = options.filter(option =>
            (option.productCategoryName && option.productCategoryName.toLowerCase().includes(trimmedInput))
        ).filter(option => option.productCategoryName !== null);

        const exactMatchOptions = [];
        const nonExactMatchOptions = [];
        filteredOptions.forEach(option => {
            if (
                option.productCategoryName.toLowerCase() === trimmedInput
            ) {
                exactMatchOptions.push(option);
            } else {
                nonExactMatchOptions.push(option);
            }
        });

        return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Add Selling Price |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/dashboard/viewSellingPrice"}
                        btname="Back"
                        pageName={pageProps.pageName}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={4}>
                                {pageProps.isEdit ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Grid item md={4} xs={12}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    size="small"
                                                    label="Group *"
                                                    value={formik.values.groupID}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('groupID')}
                                                    error={Boolean(touched.groupID && errors.groupID)}
                                                    helperText={touched.groupID && errors.groupID}
                                                    InputProps={{
                                                        readOnly: !permissionList.isGroupFilterEnabled
                                                    }}
                                                >
                                                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                                                    {groupList.map((option) => (
                                                        <MenuItem key={option.groupID} value={option.groupID}>
                                                            {option.groupName}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                            <Grid Grid item md={4} xs={12}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Product Category Name *"
                                                    value={formik.values.productCategoryName}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('productCategoryName')}
                                                    error={Boolean(touched.productCategoryName && errors.productCategoryName)}
                                                    helperText={touched.productCategoryName && errors.productCategoryName}
                                                    InputProps={{
                                                        readOnly: true
                                                    }}
                                                />
                                            </Grid>
                                            <Grid Grid item md={4} xs={12}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Product Name *"
                                                    value={formik.values.productName}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('productName')}
                                                    error={Boolean(touched.productName && errors.productName)}
                                                    helperText={touched.productName && errors.productName}
                                                    InputProps={{
                                                        readOnly: true
                                                    }}
                                                />
                                            </Grid>
                                        </Stack>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Grid item md={4} xs={12}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DatePicker
                                                            label="Date *"
                                                            maxDate={new Date()}
                                                            value={formik.values.fromDate}
                                                            onChange={(newValue) => {
                                                                setFromDate(newValue);
                                                                formik.setFieldValue("fromDate", newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    fullWidth
                                                                    size="small"
                                                                    error={Boolean(touched.fromDate && errors.fromDate)}
                                                                    helperText={touched.fromDate && errors.fromDate}
                                                                    InputProps={{
                                                                        readOnly: true
                                                                    }}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                        </Grid>  
                                        <Grid item md={4} xs={12}>
                                        <TextField
                                                fullWidth
                                                size="small"
                                                label="Selling Price *"
                                                value={formik.values.sellingPrice}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('sellingPrice')}
                                                error={Boolean(touched.sellingPrice && errors.sellingPrice)}
                                                helperText={touched.sellingPrice && errors.sellingPrice}
                                            />
                                        </Grid>
                                        <Grid item md={4} xs={12}>
                                        <TextField
                                                fullWidth
                                                size="small"
                                                label="Proposed Price *"
                                                value={formik.values.proposedPrice}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('proposedPrice')}
                                                error={Boolean(touched.proposedPrice && errors.proposedPrice)}
                                                helperText={touched.proposedPrice && errors.proposedPrice}
                                            />
                                        </Grid>
                                                                                
                                        </Stack>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Grid item md={4} xs={12}>
                                            <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Competitor Price "
                                                    value={formik.values.competitorPrice}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('competitorPrice')}
                                                    error={Boolean(touched.competitorPrice && errors.competitorPrice)}
                                                    helperText={touched.competitorPrice && errors.competitorPrice}
                                                />
                                        </Grid>
                                        </Stack>
                                    </>
                                ) : (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Grid item md={4} xs={12}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    size="small"
                                                    label="Group *"
                                                    value={formik.values.groupID}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('groupID')}
                                                    error={Boolean(touched.groupID && errors.groupID)}
                                                    helperText={touched.groupID && errors.groupID}
                                                    InputProps={{
                                                        readOnly: !permissionList.isGroupFilterEnabled
                                                    }}
                                                >
                                                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                                                    {groupList.map((option) => (
                                                        <MenuItem key={option.groupID} value={option.groupID}>
                                                            {option.groupName}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <Autocomplete
                                                    key={IsClear}
                                                    fullWidth
                                                    id="productCategoryID"
                                                    options={productcatogery}
                                                    filterOptions={filterOptions}
                                                    getOptionLabel={(option) => option.productCategoryName || ''}
                                                    value={productcatogery.find(option => option.productCategoryID === formik.values.productCategoryID) || null}
                                                    onChange={(e, value) => formik.setFieldValue('productCategoryID', value ? value.productCategoryID : '')}
                                                    renderInput={(params) =>
                                                        <TextField {...params}
                                                            variant="outlined"
                                                            name="productCategoryID"
                                                            label="Product Category *"
                                                            size="small"
                                                            fullWidth
                                                            helperText={formik.touched.productCategoryID && formik.errors.productCategoryID}
                                                            error={Boolean(formik.touched.productCategoryID && formik.errors.productCategoryID)}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <Autocomplete
                                                    fullWidth
                                                    key={IsClear}
                                                    id="productID"
                                                    options={product}
                                                    getOptionLabel={(option) => option.productName || ''}
                                                    value={product.find(option => option.productID === formik.values.productID) || null}
                                                    onChange={(e, value) => formik.setFieldValue('productID', value ? value.productID : '')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            name="productID"
                                                            label="Product *"
                                                            size="small"
                                                            fullWidth
                                                            helperText={formik.touched.productID && formik.errors.productID}
                                                            error={Boolean(formik.touched.productID && formik.errors.productID)}
                                                        />
                                                    )}
                                                />
                                            </Grid>
                                        </Stack>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Grid item md={4} xs={12}>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DatePicker
                                                            label="Date *"
                                                            maxDate={new Date()}
                                                            value={formik.values.fromDate}
                                                            onChange={(newValue) => {
                                                                setFromDate(newValue);
                                                                formik.setFieldValue("fromDate", newValue);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    fullWidth
                                                                    size="small"
                                                                    error={Boolean(touched.fromDate && errors.fromDate)}
                                                                    helperText={touched.fromDate && errors.fromDate}
                                                                />
                                                            )}
                                                        />
                                                    </LocalizationProvider>
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Selling Price * "
                                                    value={formik.values.sellingPrice}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('sellingPrice')}
                                                    error={Boolean(touched.sellingPrice && errors.sellingPrice)}
                                                    helperText={touched.sellingPrice && errors.sellingPrice}
                                                />
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Proposed Price * "
                                                    value={formik.values.proposedPrice}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('proposedPrice')}
                                                    error={Boolean(touched.proposedPrice && errors.proposedPrice)}
                                                    helperText={touched.proposedPrice && errors.proposedPrice}
                                                />
                                            </Grid> 
                                        </Stack>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Grid item md={4} xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Competitor Price "
                                                        value={formik.values.competitorPrice}
                                                        onChange={formik.handleChange}
                                                        {...getFieldProps('competitorPrice')}
                                                        error={Boolean(touched.competitorPrice && errors.competitorPrice)}
                                                        helperText={touched.competitorPrice && errors.competitorPrice}
                                                    />
                                             </Grid>
                                        </Stack>
                                    </>
                                )}
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                value={formik.values.isActive}
                                                checked={formik.values.isActive}
                                                {...getFieldProps('isActive')}
                                                onClick={formik.handleChange}
                                                color='error'
                                                name="isActive"
                                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                            />}
                                        label="Is Active"
                                    />
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    {!pageProps.isEdit && (
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color="error"
                                            onClick={() => clearAll()}
                                        >
                                            Clear
                                        </Button>
                                    )}
                                    <Button
                                        disabled={isButtonEnable}
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        {pageProps.submitButtonName}
                                    </Button>
                                </Stack>
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}

